import * as Styled from './styled';

import { IRepositoryEntry, IRepository } from '@/types';
import VideoRenderer from '@/components/VideoRenderer';
import AudioRenderer from '@/components/AudioRenderer';
import { Row, Stack } from '@/ui/primatives';
import * as format from '@/lib/format';

const MediaFileView: React.FC<{ repository: IRepository; entry: IRepositoryEntry; fileUrl?: string; }> = ({ repository, entry, fileUrl }) => {
  const fileType = entry.mime_type;

  const isAudioFile = entry?.data_type === 'audio' || entry?.mime_type?.includes('audio');

  return (
    <Stack gap={10}>
      <Row justifyContent="space-between">
        <div className="mono">{entry.mime_type}</div>
        <div className="mono">{format.humanFileSize(entry.size)}</div>
      </Row>
      {isAudioFile ? (
        <AudioRenderer url={fileUrl!} />
      ) : (
        <Styled.VideoFileView>
          <VideoRenderer audioOnlyMode={isAudioFile} path={fileUrl!} type={fileType as string} />
        </Styled.VideoFileView>
      )}
    </Stack>
  );
};

export default MediaFileView;
